import { ExperiencePayload } from '../Types';
import { SortOption } from '../../Builder/ExperienceCatalog/SortTemplate/Types';

const compareSort = <T extends string | Date>(a: T, b: T) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const sortExperiences = <T extends { readonly payload: ExperiencePayload }>(
  sortOption: SortOption,
  experiences: ReadonlyArray<T>,
): T[] => {
  // Create a mutable copy for sorting
  const expArray = [...experiences];

  switch (sortOption.value) {
    case 'trending-first':
      // Partition into featured and non-featured
      const featuredExps = expArray.filter((exp) => exp.payload.featured.isJust());
      const otherExps = expArray.filter((exp) => !exp.payload.featured.isJust());

      // Sort featured by featured date (newest first)
      const sortedFeatured = featuredExps.sort((a, b) => {
        return a.payload.featured
          .andThen((aDate) => b.payload.featured.map((bDate) => compareSort(bDate, aDate)))
          .getOrElseValue(0);
      });

      // Sort non-featured alphabetically
      const sortedOther = otherExps.sort((a, b) => compareSort(a.payload.title, b.payload.title));

      return sortedFeatured.concat(sortedOther);

    case 'alphabetical-asc':
      return expArray.sort((a, b) => compareSort(a.payload.title, b.payload.title));

    case 'alphabetical-desc':
      return expArray.sort((a, b) => compareSort(b.payload.title, a.payload.title));
  }
};
